export default __webpack_public_path__ + "static/media/png_logo_NSL.618c5853.png";